<template>
  <div>
    <Card>
      <template #content>
        <CoreForm
          v-model:title="form.title"
          v-model:new-attached="form.newAttached"
          v-model:published-at="form.publishedAt"
          v-model:unpublished-at="form.unpublishedAt"
          v-model:remarks="form.remarks"
          :errors="errors"
        />

        <span class="text-danger">
          動画のアップロードには時間がかかります。<br />
          アップロードが完了するまで、ページを閉じないでください。
        </span>

        <div v-if="loading" class="mt-4 mb-2">
          <i class="pi pi-spin pi-spinner"></i>
          <span class="ms-2">アップロード中...</span>
        </div>
        <ProgressBar
          v-if="loading || progress > 0"
          :value="progress"
          class=""
        />

        <div class="d-flex justify-content-center my-4">
          <BasicButton
            label="キャンセル"
            variant="secondary"
            class="me-5"
            outlined
            :disabled="loading"
            @click="backto"
          />
          <BasicButton
            label="作成"
            button-type="submit"
            :disabled="loading"
            @click="submit"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import {
  useRouterUtil,
  useTrainings,
  useZodScheme,
  useGcp,
} from "/@/vue/composables";
import { BasicButton } from "/@/vue/components/Atom";
import { Form as CoreForm } from "/@/vue/components/Organisms/Users/Trainings";
import { TrainingCheckSchema, TrainingForm } from "/@/types";
import { errorHandle } from "/@/modules/error";
import Card from "primevue/card";
import ProgressBar from "primevue/progressbar";

const { backto, goto, currentRouteQuery } = useRouterUtil();

const selectedOrganizationId = computed(() => {
  return currentRouteQuery.value.organizationId as number;
});

function resetForm() {
  form.title = undefined;
  form.newAttached = undefined;
}

const { useFormAndErrors } = useZodScheme();
const { form, errors, startValidation } =
  useFormAndErrors<TrainingForm>(TrainingCheckSchema);

watch(form, (f) => {
  if (f.title && f.title.length > 30) {
    form.title = f.title.slice(0, 30);
  }

  if (f.remarks && f.remarks.length > 1000) {
    form.remarks = f.remarks.slice(0, 1000);
  }
});

const { createTraining } = useTrainings();

startValidation.value = true;
const loading = ref(false);

const { uploadingMp4 } = useGcp();

const progress = ref(0);

async function submit() {
  try {
    const file = form.newAttached;
    if (!file) return;

    loading.value = true;

    const { fileName } = await uploadingMp4(file, (percent) => {
      progress.value = percent;
    });

    const trainng = TrainingCheckSchema.parse({
      ...form,
      fileName,
    });

    await createTraining(selectedOrganizationId.value, trainng);

    window.alert("アップロードが完了しました");
    goto({ name: "UsersSystemAdminTrainingsIndex" });
  } catch (e) {
    errorHandle(e);
  } finally {
    loading.value = false;
    progress.value = 0;
  }
}
</script>

<style scoped></style>
